import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import placeholderImg from '../../../images/autzu-newsroom.svg';

const LatestNews = () => {
  const [profile, setProfile] = useState();
  const [posts, setPosts] = useState();

  const mediumURL =
    'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40autzu&api_key=tfo3jdrzarblsu0o1omp7e5fdg2bj8ffxxl1igx3';
  useEffect(() => {
    fetch(mediumURL)
      .then(res => res.json())
      .then(data => {
        const avatar = data.feed.image;
        const profileLink = data.feed.link;
        const res = data.items; //This is an array with the content. No feed, no info about author etc..

        const title = data.feed.title;

        setProfile({ avatar: avatar, link: profileLink, title: title });
        setPosts(res);
      })
      .catch(e => {
        console.log(e);
      });
  }, []);

  const newTo = { pathname: '/articles', posts: posts };
  const isMobile = window.innerWidth < 768;

  return (
    <div className="latestNewsContainer container">
      <div className="newsTitle">
        <div
          style={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '32px',
            width: isMobile ? '260px' : null
          }}>
          Latest News from Autzu
        </div>
        <Link
          to={newTo}
          style={{
            textDecoration: 'none'
          }}>
          <div className="clickableButton">View all articles</div>
        </Link>
      </div>
      <div className="newsArticleContainer">
        {posts &&
          posts.slice(0, 3).map(post => (
            <a
              href={post.link}
              target="_blank"
              style={{ textDecoration: 'none', color: '#414141' }}>
              <div className="articleBox">
                <div className="articleImage">
                  <img
                    src={
                      post.thumbnail.includes('.png')
                        ? post.thumbnail
                        : placeholderImg
                    }
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}></img>
                </div>

                <div className="articleInfo">
                  <div style={{ fontWeight: 700 }}>{post.title}</div>
                  <div className="articleSubscript">
                    {moment(post.pubDate).format('MMM DD, YYYY')}
                  </div>
                </div>
              </div>
            </a>
          ))}
      </div>
    </div>
  );
};

export default LatestNews;



// WEBPACK FOOTER //
// ./src/components/Newsroom/LatestNews/index.js